<header data-testid="t-oc-navbar-header-1752672977568-1">
    <div
        class="header-inner"
        [ngClass]="currentBg()"
        data-testid="t-oc-navbar-div-1752672977568-10"
    >
        <!-- Brand -->
        <a
            routerLink="home/"
            class="logo"
            data-testid="t-oc-navbar-a-1752672977568-1"
        >
            <img
                loading="lazy"
                src="assets/img/logo_orgacard_desktop.svg"
                class="d-block"
                alt
                data-testid="t-oc-navbar-img-1752672977568-1"
            />
        </a>

        <!-- Sidenav toggle -->
        @if (sidenavToggle()) {
            <div
                class="toggle-sidebar"
                data-testid="t-oc-navbar-div-1752672977568-1"
            >
                <a
                    class="btn action--btn btn-primary-dark"
                    (click)="toggleSidenav()"
                    [ngbTooltip]="'mws.layoutnavbar.navigation' | i18n"
                    data-testid="t-oc-navbar-a-1752672977568-2"
                >
                    <i
                        class="oc-flyout align-middle"
                        data-testid="t-oc-navbar-i-1752672977568-1"
                    ></i>
                </a>
            </div>
        }
        @if (currentUserCostcenter) {
            <!--  style="background-color: var(--bs-primary-dark); color: var(--bs-body-color-inverse); padding: 10px 14px" -->
            <div data-testid="t-oc-navbar-div-1778158590764-1">
                {{ currentUserCostcenterName }}
            </div>
        }

        <!-- Aktuelle Umgebung -->
        <div
            class="current-environment d-none d-lg-block mx-auto"
            [style.background-color]="environmentService.mandator.name.indexOf('_TEST') > -1 ? 'red' : null"
            data-testid="t-oc-navbar-div-1752672977568-2"
        >
            <span data-testid="t-oc-navbar-span-1752672977568-1"
                ><i
                    [ngClass]="environmentService.appSettings.applicationName === 'OCMWSI' ? 'oc-internetplatform' : 'oc-portal'"
                    data-testid="t-oc-navbar-i-1752672977568-2"
                ></i
            ></span>
            <span data-testid="t-oc-navbar-span-1752672977568-2">{{ (environmentService.ocmwsi ? 'mws.internetplatform' : 'mws.home') | i18n }}</span>
        </div>

        <!-- User Menu -->
        <div
            id="userMenu"
            class="dropdown-primary ms-auto"
            ngbDropdown
            placement="bottom-end"
            display="dynamic"
            data-testid="t-oc-navbar-div-1752672977568-7"
        >
            <a
                class="btn btn-primary-dark action--btn"
                ngbDropdownToggle
                [ngbTooltip]="'mws.layoutnavbar.options' | i18n"
                (click)="fillAttributes()"
                data-testid="t-oc-navbar-a-1752672977568-3"
            >
                <i
                    [ngClass]="environmentService.systemUserGender ? environmentService.systemUserGender.styleClass : 'oc-gender-unknown'"
                    data-testid="t-oc-navbar-i-1752672977568-3"
                ></i>
            </a>
            <ul
                ngbDropdownMenu
                class="dropdown-menu dropdown-menu-end"
                data-testid="t-oc-navbar-ul-1752672977568-1"
            >
                <!-- Informationstext -->
                <li data-testid="t-oc-navbar-li-1752672977568-1">
                    <strong
                        class="dropdown-item-text"
                        data-testid="t-oc-navbar-strong-1752672977568-1"
                        >{{ environmentService?.systemUser.firstname }} {{ environmentService?.systemUser.name }}</strong
                    >
                </li>

                @if (currentUserCostcenter) {
                    <li data-testid="t-oc-navbar-li-1752672977568-2">
                        <span
                            class="dropdown-item-text"
                            data-testid="t-oc-navbar-span-1752672977568-3"
                            >{{ 'mws.loggedinas' | i18n }}:
                            <br data-testid="t-oc-navbar-br-1752672977568-1" />
                            {{ currentUserCostcenterName }}
                        </span>
                    </li>
                }

                @if (environmentService.userCostcenterTree) {
                    <li
                        (click)="openCostcenterModal()"
                        data-testid="t-oc-navbar-li-1752672977568-3"
                    >
                        <div
                            class="dropdown-item"
                            data-testid="t-oc-navbar-div-1752672977568-3"
                        >
                            <i
                                class="oc-pay"
                                data-testid="t-oc-navbar-i-1752672977568-4"
                            ></i>
                            {{ 'mws.costcenters' | i18n }}
                        </div>
                    </li>
                }

                <!-- showSettings toSettings-->
                <li
                    (click)="toSettings()"
                    data-testid="t-oc-navbar-li-1752672977568-4"
                >
                    <div
                        class="dropdown-item"
                        data-testid="t-oc-navbar-div-1752672977568-4"
                    >
                        <i
                            class="oc-general-settings"
                            data-testid="t-oc-navbar-i-1752672977568-5"
                        ></i>
                        {{ 'mws.navbar.account' | i18n }}
                    </div>
                </li>

                <!-- show information -->
                <li
                    (click)="showInformation()"
                    data-testid="t-oc-navbar-li-1752672977568-5"
                >
                    <div
                        class="dropdown-item"
                        data-testid="t-oc-navbar-div-1752672977568-5"
                    >
                        <i
                            class="oc-general-info"
                            data-testid="t-oc-navbar-i-1752672977568-6"
                        ></i>
                        {{ 'mws.navbar.information' | i18n }}
                    </div>
                </li>

                <li
                    (click)="logout()"
                    data-testid="t-oc-navbar-li-1752672977568-6"
                >
                    <div
                        class="dropdown-item"
                        data-testid="t-oc-navbar-div-1752672977568-6"
                    >
                        <i
                            class="oc-general-logout"
                            data-testid="t-oc-navbar-i-1752672977568-7"
                        ></i>
                        {{ 'mws.navbar.logout' | i18n }}
                    </div>
                </li>
            </ul>
        </div>

        <!-- Language Menu -->
        <div
            placement="bottom-right"
            ngbDropdown
            class="dropdown-primary"
            data-testid="t-oc-navbar-div-1752672977568-9"
        >
            <a
                class="btn btn-primary-dark action--btn"
                ngbDropdownToggle
                ngbTooltip="{{ 'mws.layoutnavbar.language' | i18n }}"
                data-testid="t-oc-navbar-a-1752672977568-4"
            >
                <i
                    class="oc-earth"
                    data-testid="t-oc-navbar-i-1752672977568-8"
                ></i>
            </a>
            <ul
                ngbDropdownMenu
                class="dropdown-menu"
                data-testid="t-oc-navbar-ul-1752672977568-2"
            >
                @for (v of environmentService.variantList; track v) {
                    <li
                        (click)="setLanguage(v)"
                        data-testid="t-oc-navbar-li-1752672977568-7"
                    >
                        <div
                            class="dropdown-item"
                            data-testid="t-oc-navbar-div-1752672977568-8"
                        >
                            <i
                                class="oc-flag oc-flag-{{ v.variant.split('_')[1].toLowerCase() }}"
                                data-testid="t-oc-navbar-i-1752672977568-9"
                            ></i>
                            <i
                                class="oc-flag oc-flag-{{ v.variant.split('_')[0].toLowerCase() }}"
                                data-testid="t-oc-navbar-i-1752672977568-10"
                            ></i>
                            &nbsp;{{ v.description }}&nbsp;
                        </div>
                    </li>
                }
            </ul>
        </div>
    </div>
</header>

<ng-template
    #informationModal
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        data-testid="t-oc-navbar-div-1752672977568-11"
    >
        <button
            type="button"
            class="btn-close btn"
            (click)="d('Cross click')"
            data-testid="t-oc-navbar-button-1752672977568-1"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-oc-navbar-i-1752672977568-11"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-oc-navbar-span-1752672977568-4"
        >
            {{ 'mws.navbar.information' | i18n }}
        </span>
    </div>

    <div
        class="modal-body"
        data-testid="t-oc-navbar-div-1752672977568-21"
    >
        <div
            class="settings"
            data-testid="t-oc-navbar-div-1752672977568-20"
        >
            <div
                class="row g-3"
                data-testid="t-oc-navbar-div-1752672977568-19"
            >
                <div
                    class="col-12 col-md-4 col-lg-3"
                    data-testid="t-oc-navbar-div-1752672977568-12"
                >
                    <strong data-testid="t-oc-navbar-strong-1752672977568-2">{{ 'mws.information.applicationname' | i18n }}:</strong>
                </div>
                <div
                    class="col-12 col-md-8 col-lg-9"
                    data-testid="t-oc-navbar-div-1752672977568-13"
                >
                    {{ environmentService.versionData.backendname }}
                </div>

                <div
                    class="col-12 col-md-4 col-lg-3"
                    data-testid="t-oc-navbar-div-1752672977568-14"
                >
                    <strong data-testid="t-oc-navbar-strong-1752672977568-3">{{ 'mws.information.version.frontend' | i18n }}:</strong>
                </div>
                <div
                    class="col-12 col-md-8 col-lg-9"
                    data-testid="t-oc-navbar-div-1752672977568-15"
                >
                    {{ env.version }}
                </div>

                <div
                    class="col-12 col-md-4 col-lg-3"
                    data-testid="t-oc-navbar-div-1752672977568-16"
                >
                    <strong data-testid="t-oc-navbar-strong-1752672977568-4">{{ 'mws.information.version.backend' | i18n }}:</strong>
                </div>

                <div
                    class="col-12 col-md-8 col-lg-9"
                    data-testid="t-oc-navbar-div-1752672977568-17"
                >
                    {{ environmentService.versionData.backendversion }}
                </div>

                <div
                    class="col-12"
                    data-testid="t-oc-navbar-div-1752672977568-18"
                >
                    <a
                        [cdkCopyToClipboard]="info"
                        [cdkCopyToClipboardAttempts]="5"
                        class="btn btn-primary me-3"
                        [attr.aria-label]="'mws.information.clipboard' | i18n"
                        href="javascript:void(0)"
                        ngbTooltip="{{ 'mws.information.clipboard' | i18n }}"
                        data-testid="t-oc-navbar-a-1752672977568-5"
                    >
                        <i
                            class="oc-copy"
                            data-testid="t-oc-navbar-i-1752672977568-12"
                        ></i>
                        &nbsp;
                        {{ 'mws.information.clipboard' | i18n }}
                    </a>

                    <a
                        class="btn btn-primary"
                        [attr.aria-label]="'mws.information.version.support' | i18n"
                        [href]="'mws.information.version.support.link' | i18n"
                        target="_blank"
                        ngbTooltip="{{ 'mws.information.version.support' | i18n }}"
                        data-testid="t-oc-navbar-a-1752672977568-6"
                    >
                        <i
                            class="oc-copy"
                            data-testid="t-oc-navbar-i-1752672977568-13"
                        ></i>
                        &nbsp;
                        {{ 'mws.information.version.support' | i18n }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Modal template COSTCENTER -->
<ng-template
    #costcenterModal
    let-c="close"
    let-d="dismiss"
>
    <app-costcentertree
        [modalMessageTitle]="costcenterModalHeadline"
        (cancelButton)="cancelCostcenter()"
        (checkButton)="checkCurrentUserCostcenter($event)"
        [treeDisabled]="false"
        [multipleSelect]="false"
        [useTriState]="false"
        [nodes]="environmentService.userCostcenterTreeNodes"
        [d]="d"
        [c]="c"
        [expandAll]="true"
        data-testid="t-oc-navbar-app-costcentertree-1752672977568-1"
    />
</ng-template>
